module.exports = __webpack_public_path__ + "img/anime-portrait.8cac6c7c.jpg";